import Link from '@commons/components/Link';

import type { WhitePaperNodeProps } from '.';

/**
 * WhitePaper node component for the Label display type.
 */

const WhitePaperNodeLabel = ({ title, alias }: WhitePaperNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default WhitePaperNodeLabel;
